<template>
    <div>
        <div class="modal-backdrop show"></div>
        <div class="modal d-block" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ $t('edit_product_type') }}</h5>
                        <button type="button" class="close" @click="$emit('close')">
                        <span>&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <label for="description">Description</label>
                         <app-input
                            type="text"
                            class="form-control"
                            v-model="description"
                            placeholder="Product type name"
                        />
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="$emit('close')">
                            Close
                        </button>
                        &nbsp;
                        <button type="button" class="btn btn-primary" @click="submit">
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>

import { getDetail } from "./api/api";

export default {
    name: "EditDetail",
    props :{
        id: {
            type: String|Number,
            default: null
        },
    },
    data() {
        return {
            isDataLoaded : false,
            description : null,
        };
    },
    methods: {
        submit() {
            const data = {
                id_condition : this.id,
                description : this.description,
            }
            this.$emit("save", data);
        },

        async getData(id) {
            const res = await getDetail(id);
            if (res.data) {
                this.description = res.data.product_type;
            }
        }
    },
    mounted(){
        if (this.id) {
            this.getData(this.id);  
        }
    }
};
</script>
  